import { createContext, useContext, useEffect, useState } from "react";

export const LANGS = ["pt", "ru", "en", "fr"];

export const CONTACTS = {
  phone: "+351 925 948 568",
  phoneHref: "tel:+351925948568",
  whatsapp: "https://wa.me/351925948568",
  email: "proalp22construcao@gmail.com",
  address: "Lisboa, Portugal",
  facebook: "https://www.facebook.com/profile.php?id=61574129461376",
};

export const loc = (field, lang) =>
  field && typeof field === "object" ? field[lang] || field.pt || "" : field || "";

const translations = {
  pt: {
    nav: { home: "Início", what: "O Que Fazemos", services: "Serviços", projects: "Projetos", about: "Sobre Nós", reviews: "Avaliações", socials: "Redes Sociais", contacts: "Contactos" },
    headerCta: "Pedir Orçamento",
    hero: {
      kicker: "Construção & Trabalhos em Altura — Portugal",
      line1: "CONSTRUÇÃO",
      line2: "& ALTURA",
      line3: "SEM LIMITES",
      sub: "A PROALP22 executa trabalhos de construção e em altura em todo o Portugal — com segurança certificada, qualidade premium e prazos garantidos.",
      cta1: "Obter Consulta Gratuita",
      cta2: "Ver Nossos Projetos",
      stats: [
        { n: "7+", l: "anos de experiência" },
        { n: "250+", l: "projetos concluídos" },
        { n: "100%", l: "segurança certificada" },
      ],
      scroll: "Deslize para explorar",
    },
    marquee: ["Acesso por Cordas", "Fachadas", "Pintura", "Coberturas", "Construção Civil", "Manutenção", "Industrial", "Impermeabilização"],
    what: {
      num: "01", title: "O Que Fazemos",
      sub: "Especialistas em trabalhos de construção e em altura para edifícios residenciais, comerciais e industriais.",
      more: "Saber mais",
      items: [
        { t: "Trabalhos em Altura", d: "Acesso por cordas para qualquer intervenção — sem andaimes, sem complicações." },
        { t: "Fachadas & Pintura", d: "Reabilitação, restauro e pintura de fachadas com materiais premium." },
        { t: "Construção & Reparação", d: "Construção civil, reparação e manutenção integral de edifícios." },
        { t: "Coberturas & Industrial", d: "Telhados, estruturas metálicas e manutenção industrial especializada." },
      ],
    },
    services: { num: "02", title: "Nossos Serviços", sub: "Catálogo completo de serviços. Escolha o que precisa — nós tratamos do resto.", order: "Pedir Este Serviço", benefits: "Vantagens" },
    projects: {
      num: "03", title: "Nossos Projetos", sub: "Uma seleção de obras concluídas em todo o Portugal.", all: "Todos", view: "Ver projeto", before: "Antes", after: "Depois",
      filters: { fachadas: "Fachadas", pintura: "Pintura", altura: "Altura", reparacao: "Reparação", outro: "Outro" },
    },
    why: {
      num: "04", title: "Porquê a PROALP22", sub: "A confiança dos nossos clientes constrói-se com resultados.",
      stats: [
        { n: "7+", l: "anos no mercado" },
        { n: "250+", l: "projetos entregues" },
        { n: "40+", l: "especialistas" },
        { n: "98%", l: "clientes satisfeitos" },
      ],
      items: [
        { t: "Equipa Profissional", d: "Técnicos certificados com formação contínua em segurança e novas técnicas." },
        { t: "Experiência Comprovada", d: "7 anos de obras em edifícios residenciais, comerciais e industriais." },
        { t: "Materiais de Qualidade", d: "Trabalhamos apenas com marcas premium e materiais certificados." },
        { t: "Prazos Cumpridos", d: "Planeamento rigoroso e cumprimento dos prazos acordados, sem desculpas." },
        { t: "Segurança Total", d: "Protocolos de segurança rigorosos e seguro de responsabilidade civil completo." },
        { t: "Abordagem Individual", d: "Cada projeto é único — soluções à medida do seu edifício e do seu orçamento." },
        { t: "Garantia de Obra", d: "Garantia escrita em todos os trabalhos executados pela nossa equipa." },
        { t: "Particulares & Empresas", d: "Trabalhamos com condomínios, empresas, hotéis e clientes particulares." },
      ],
    },
    about: {
      num: "05", title: "Sobre a PROALP22",
      p1: "A PROALP22 é uma empresa portuguesa especializada em trabalhos de construção e em altura. Há mais de 7 anos que executamos projetos de reabilitação, pintura, coberturas e manutenção em todo o país — de condomínios residenciais a hotéis e instalações industriais.",
      p2: "A nossa equipa é composta por técnicos certificados em acesso por cordas e construção civil. Trabalhamos com rigor, materiais premium e total transparência — do orçamento à entrega final.",
      bullets: ["Equipa certificada em acesso por cordas", "Seguro de responsabilidade civil completo", "Relatórios fotográficos de cada intervenção", "Orçamento gratuito em 24 horas"],
      badge: "anos de experiência",
    },
    reviews: { num: "06", title: "O Que Dizem os Clientes", sub: "Avaliações reais de quem confiou na PROALP22." },
    socials: { num: "07", title: "Siga-nos nas Redes Sociais", sub: "Acompanhe os nossos projetos, novidades e bastidores das obras.", follow: "Seguir" },
    cta: { title: "Precisa de trabalhos de construção ou em altura?", sub: "Contacte a PROALP22 e receba uma consulta gratuita e sem compromisso.", call: "Ligar Agora", whatsapp: "WhatsApp", quote: "Pedir Orçamento" },
    contact: {
      num: "08", title: "Contactos", sub: "Fale connosco — respondemos em menos de 24 horas.",
      phone: "Telefone", email: "Email", address: "Morada",
      formTitle: "Pedido de Orçamento", name: "Nome", phoneF: "Telefone", emailF: "Email",
      service: "Que serviço procura?", servicePh: "Escolha um serviço", message: "Mensagem",
      submit: "Enviar Pedido", sending: "A enviar...",
      success: "Obrigado! Recebemos o seu pedido e entraremos em contacto brevemente.",
      error: "Erro ao enviar. Tente novamente ou ligue-nos.",
    },
    footer: { desc: "Trabalhos profissionais de construção e em altura em Portugal. Segurança, qualidade e prazos garantidos.", nav: "Navegação", services: "Serviços", contacts: "Contactos", rights: "Todos os direitos reservados.", privacy: "Política de Privacidade", cookie: "Política de Cookies" },
    mobile: { call: "Ligar", whatsapp: "WhatsApp", quote: "Orçamento" },
  },
  ru: {
    nav: { home: "Главная", what: "Что мы делаем", services: "Услуги", projects: "Наши проекты", about: "О компании", reviews: "Отзывы", socials: "Соцсети", contacts: "Контакты" },
    headerCta: "Получить расчёт",
    hero: {
      kicker: "Строительство и высотные работы — Португалия",
      line1: "СТРОИМ",
      line2: "НА ВЫСОТЕ",
      line3: "БЕЗ ГРАНИЦ",
      sub: "PROALP22 выполняет строительные и высотные работы по всей Португалии — с сертифицированной безопасностью, премиальным качеством и гарантией сроков.",
      cta1: "Получить консультацию",
      cta2: "Смотреть проекты",
      stats: [
        { n: "7+", l: "лет опыта" },
        { n: "250+", l: "проектов выполнено" },
        { n: "100%", l: "сертифицированная безопасность" },
      ],
      scroll: "Листайте вниз",
    },
    marquee: ["Высотные работы", "Фасады", "Покраска", "Кровля", "Строительство", "Обслуживание", "Промышленность", "Гидроизоляция"],
    what: {
      num: "01", title: "Что Мы Делаем",
      sub: "Специалисты по строительным и высотным работам для жилых, коммерческих и промышленных зданий.",
      more: "Подробнее",
      items: [
        { t: "Высотные работы", d: "Канатный доступ для любых работ — без лесов и лишних сложностей." },
        { t: "Фасады и покраска", d: "Ремонт, реставрация и покраска фасадов премиальными материалами." },
        { t: "Строительство и ремонт", d: "Строительные работы, ремонт и комплексное обслуживание зданий." },
        { t: "Кровля и промышленность", d: "Крыши, металлоконструкции и промышленное обслуживание." },
      ],
    },
    services: { num: "02", title: "Наши Услуги", sub: "Полный каталог услуг. Выберите нужную — об остальном позаботимся мы.", order: "Заказать услугу", benefits: "Преимущества" },
    projects: {
      num: "03", title: "Наши Проекты", sub: "Подборка завершённых объектов по всей Португалии.", all: "Все", view: "Смотреть проект", before: "До", after: "После",
      filters: { fachadas: "Фасады", pintura: "Покраска", altura: "Высота", reparacao: "Ремонт", outro: "Другое" },
    },
    why: {
      num: "04", title: "Почему PROALP22", sub: "Доверие наших клиентов строится на результатах.",
      stats: [
        { n: "7+", l: "лет на рынке" },
        { n: "250+", l: "объектов сдано" },
        { n: "40+", l: "специалистов" },
        { n: "98%", l: "довольных клиентов" },
      ],
      items: [
        { t: "Профессиональная команда", d: "Сертифицированные специалисты с постоянным обучением безопасности и новым техникам." },
        { t: "Опыт работы", d: "7 лет работ на жилых, коммерческих и промышленных объектах." },
        { t: "Качественные материалы", d: "Работаем только с премиальными брендами и сертифицированными материалами." },
        { t: "Соблюдение сроков", d: "Точное планирование и выполнение работ в оговорённые сроки, без оправданий." },
        { t: "Полная безопасность", d: "Строгие протоколы безопасности и полная страховка гражданской ответственности." },
        { t: "Индивидуальный подход", d: "Каждый проект уникален — решения под ваше здание и ваш бюджет." },
        { t: "Гарантия на работы", d: "Письменная гарантия на все работы, выполненные нашей командой." },
        { t: "Частные и коммерческие объекты", d: "Работаем с кондоминиумами, компаниями, отелями и частными клиентами." },
      ],
    },
    about: {
      num: "05", title: "О Компании",
      p1: "PROALP22 — португальская компания, специализирующаяся на строительных и высотных работах. Более 7 лет мы реализуем проекты реставрации, покраски, кровли и обслуживания по всей стране — от жилых кондоминиумов до отелей и промышленных объектов.",
      p2: "Наша команда состоит из сертифицированных специалистов по канатному доступу и строительству. Мы работаем точно, с премиальными материалами и полной прозрачностью — от сметы до сдачи объекта.",
      bullets: ["Сертифицированная команда промышленных альпинистов", "Полная страховка гражданской ответственности", "Фотоотчёты каждого этапа работ", "Бесплатная смета за 24 часа"],
      badge: "лет опыта",
    },
    reviews: { num: "06", title: "Отзывы Клиентов", sub: "Реальные отзывы тех, кто доверился PROALP22." },
    socials: { num: "07", title: "Наши Соцсети", sub: "Следите за нашими проектами, новостями и закулисьем строек.", follow: "Подписаться" },
    cta: { title: "Нужны строительные или высотные работы?", sub: "Свяжитесь с PROALP22 и получите бесплатную консультацию без обязательств.", call: "Позвонить", whatsapp: "WhatsApp", quote: "Получить расчёт" },
    contact: {
      num: "08", title: "Контакты", sub: "Свяжитесь с нами — отвечаем в течение 24 часов.",
      phone: "Телефон", email: "Email", address: "Адрес",
      formTitle: "Форма заявки", name: "Имя", phoneF: "Телефон", emailF: "Email",
      service: "Какая услуга вас интересует?", servicePh: "Выберите услугу", message: "Сообщение",
      submit: "Отправить заявку", sending: "Отправка...",
      success: "Спасибо! Мы получили вашу заявку и свяжемся с вами в ближайшее время.",
      error: "Ошибка отправки. Попробуйте ещё раз или позвоните нам.",
    },
    footer: { desc: "Профессиональные строительные и высотные работы в Португалии. Безопасность, качество и гарантия сроков.", nav: "Навигация", services: "Услуги", contacts: "Контакты", rights: "Все права защищены.", privacy: "Политика конфиденциальности", cookie: "Политика cookies" },
    mobile: { call: "Позвонить", whatsapp: "WhatsApp", quote: "Расчёт" },
  },
  en: {
    nav: { home: "Home", what: "What We Do", services: "Services", projects: "Our Projects", about: "About Us", reviews: "Reviews", socials: "Social Media", contacts: "Contacts" },
    headerCta: "Get a Quote",
    hero: {
      kicker: "Construction & Rope Access Works — Portugal",
      line1: "CONSTRUCTION",
      line2: "& HEIGHT",
      line3: "WITHOUT LIMITS",
      sub: "PROALP22 performs construction and rope access works across Portugal — with certified safety, premium quality and guaranteed deadlines.",
      cta1: "Get a Free Consultation",
      cta2: "View Our Projects",
      stats: [
        { n: "7+", l: "years of experience" },
        { n: "250+", l: "completed projects" },
        { n: "100%", l: "certified safety" },
      ],
      scroll: "Scroll to explore",
    },
    marquee: ["Rope Access", "Facades", "Painting", "Roofing", "Construction", "Maintenance", "Industrial", "Waterproofing"],
    what: {
      num: "01", title: "What We Do",
      sub: "Specialists in construction and rope access works for residential, commercial and industrial buildings.",
      more: "Learn more",
      items: [
        { t: "Rope Access Works", d: "Rope access for any intervention — no scaffolding, no complications." },
        { t: "Facades & Painting", d: "Restoration, repair and painting of facades with premium materials." },
        { t: "Construction & Repair", d: "Civil construction, repair and full building maintenance." },
        { t: "Roofing & Industrial", d: "Roofs, metal structures and specialized industrial maintenance." },
      ],
    },
    services: { num: "02", title: "Our Services", sub: "Complete service catalog. Choose what you need — we handle the rest.", order: "Order This Service", benefits: "Benefits" },
    projects: {
      num: "03", title: "Our Projects", sub: "A selection of completed works across Portugal.", all: "All", view: "View project", before: "Before", after: "After",
      filters: { fachadas: "Facades", pintura: "Painting", altura: "Height", reparacao: "Repair", outro: "Other" },
    },
    why: {
      num: "04", title: "Why PROALP22", sub: "Our clients' trust is built on results.",
      stats: [
        { n: "7+", l: "years in the market" },
        { n: "250+", l: "projects delivered" },
        { n: "40+", l: "specialists" },
        { n: "98%", l: "satisfied clients" },
      ],
      items: [
        { t: "Professional Team", d: "Certified technicians with continuous training in safety and new techniques." },
        { t: "Proven Experience", d: "7 years of works on residential, commercial and industrial buildings." },
        { t: "Quality Materials", d: "We work only with premium brands and certified materials." },
        { t: "Deadlines Met", d: "Rigorous planning and delivery within agreed deadlines, no excuses." },
        { t: "Total Safety", d: "Strict safety protocols and full civil liability insurance." },
        { t: "Individual Approach", d: "Every project is unique — solutions tailored to your building and budget." },
        { t: "Work Warranty", d: "Written warranty on all works carried out by our team." },
        { t: "Private & Commercial", d: "We work with condominiums, companies, hotels and private clients." },
      ],
    },
    about: {
      num: "05", title: "About PROALP22",
      p1: "PROALP22 is a Portuguese company specialized in construction and rope access works. For over 7 years we have delivered restoration, painting, roofing and maintenance projects across the country — from residential condominiums to hotels and industrial facilities.",
      p2: "Our team consists of certified rope access and civil construction technicians. We work with rigor, premium materials and full transparency — from quote to final delivery.",
      bullets: ["Certified rope access team", "Full civil liability insurance", "Photographic reports of every intervention", "Free quote within 24 hours"],
      badge: "years of experience",
    },
    reviews: { num: "06", title: "What Clients Say", sub: "Real reviews from those who trusted PROALP22." },
    socials: { num: "07", title: "Follow Us on Social Media", sub: "Follow our projects, news and behind-the-scenes of our works.", follow: "Follow" },
    cta: { title: "Need construction or rope access works?", sub: "Contact PROALP22 and get a free, no-obligation consultation.", call: "Call Now", whatsapp: "WhatsApp", quote: "Get a Quote" },
    contact: {
      num: "08", title: "Contacts", sub: "Talk to us — we reply within 24 hours.",
      phone: "Phone", email: "Email", address: "Address",
      formTitle: "Quote Request", name: "Name", phoneF: "Phone", emailF: "Email",
      service: "Which service are you interested in?", servicePh: "Choose a service", message: "Message",
      submit: "Send Request", sending: "Sending...",
      success: "Thank you! We have received your request and will contact you shortly.",
      error: "Sending failed. Please try again or call us.",
    },
    footer: { desc: "Professional construction and rope access works in Portugal. Safety, quality and guaranteed deadlines.", nav: "Navigation", services: "Services", contacts: "Contacts", rights: "All rights reserved.", privacy: "Privacy Policy", cookie: "Cookie Policy" },
    mobile: { call: "Call", whatsapp: "WhatsApp", quote: "Quote" },
  },
  fr: {
    nav: { home: "Accueil", what: "Ce Que Nous Faisons", services: "Services", projects: "Nos Projets", about: "À Propos", reviews: "Avis", socials: "Réseaux Sociaux", contacts: "Contacts" },
    headerCta: "Demander un Devis",
    hero: {
      kicker: "Construction & Travaux en Hauteur — Portugal",
      line1: "CONSTRUCTION",
      line2: "& HAUTEUR",
      line3: "SANS LIMITES",
      sub: "PROALP22 réalise des travaux de construction et en hauteur dans tout le Portugal — avec une sécurité certifiée, une qualité premium et des délais garantis.",
      cta1: "Obtenir une Consultation Gratuite",
      cta2: "Voir Nos Projets",
      stats: [
        { n: "7+", l: "ans d'expérience" },
        { n: "250+", l: "projets réalisés" },
        { n: "100%", l: "sécurité certifiée" },
      ],
      scroll: "Faites défiler pour explorer",
    },
    marquee: ["Accès par Cordes", "Façades", "Peinture", "Toiture", "Construction", "Maintenance", "Industriel", "Imperméabilisation"],
    what: {
      num: "01", title: "Ce Que Nous Faisons",
      sub: "Spécialistes des travaux de construction et en hauteur pour bâtiments résidentiels, commerciaux et industriels.",
      more: "En savoir plus",
      items: [
        { t: "Travaux en Hauteur", d: "Accès par cordes pour toute intervention — sans échafaudage, sans complications." },
        { t: "Façades & Peinture", d: "Rénovation, restauration et peinture de façades avec des matériaux premium." },
        { t: "Construction & Réparation", d: "Construction, réparation et maintenance complète de bâtiments." },
        { t: "Toiture & Industriel", d: "Toits, structures métalliques et maintenance industrielle spécialisée." },
      ],
    },
    services: { num: "02", title: "Nos Services", sub: "Catalogue complet de services. Choisissez ce qu'il vous faut — nous nous occupons du reste.", order: "Commander Ce Service", benefits: "Avantages" },
    projects: {
      num: "03", title: "Nos Projets", sub: "Une sélection de chantiers réalisés dans tout le Portugal.", all: "Tous", view: "Voir le projet", before: "Avant", after: "Après",
      filters: { fachadas: "Façades", pintura: "Peinture", altura: "Hauteur", reparacao: "Réparation", outro: "Autre" },
    },
    why: {
      num: "04", title: "Pourquoi PROALP22", sub: "La confiance de nos clients se construit sur des résultats.",
      stats: [
        { n: "7+", l: "ans sur le marché" },
        { n: "250+", l: "projets livrés" },
        { n: "40+", l: "spécialistes" },
        { n: "98%", l: "clients satisfaits" },
      ],
      items: [
        { t: "Équipe Professionnelle", d: "Techniciens certifiés avec formation continue en sécurité et nouvelles techniques." },
        { t: "Expérience Prouvée", d: "7 ans de travaux sur des bâtiments résidentiels, commerciaux et industriels." },
        { t: "Matériaux de Qualité", d: "Nous travaillons uniquement avec des marques premium et des matériaux certifiés." },
        { t: "Délais Respectés", d: "Planification rigoureuse et respect des délais convenus, sans excuses." },
        { t: "Sécurité Totale", d: "Protocoles de sécurité stricts et assurance responsabilité civile complète." },
        { t: "Approche Individuelle", d: "Chaque projet est unique — des solutions adaptées à votre bâtiment et à votre budget." },
        { t: "Garantie de Travaux", d: "Garantie écrite sur tous les travaux réalisés par notre équipe." },
        { t: "Particuliers & Entreprises", d: "Nous travaillons avec copropriétés, entreprises, hôtels et particuliers." },
      ],
    },
    about: {
      num: "05", title: "À Propos de PROALP22",
      p1: "PROALP22 est une entreprise portugaise spécialisée dans les travaux de construction et en hauteur. Depuis plus de 7 ans, nous réalisons des projets de rénovation, peinture, toiture et maintenance dans tout le pays — des copropriétés résidentielles aux hôtels et installations industrielles.",
      p2: "Notre équipe est composée de techniciens certifiés en accès par cordes et en construction. Nous travaillons avec rigueur, des matériaux premium et une transparence totale — du devis à la livraison finale.",
      bullets: ["Équipe certifiée en accès par cordes", "Assurance responsabilité civile complète", "Rapports photographiques de chaque intervention", "Devis gratuit sous 24 heures"],
      badge: "ans d'expérience",
    },
    reviews: { num: "06", title: "Ce Que Disent les Clients", sub: "Avis réels de ceux qui ont fait confiance à PROALP22." },
    socials: { num: "07", title: "Suivez-nous sur les Réseaux", sub: "Suivez nos projets, nos actualités et les coulisses de nos chantiers.", follow: "Suivre" },
    cta: { title: "Besoin de travaux de construction ou en hauteur ?", sub: "Contactez PROALP22 et obtenez une consultation gratuite et sans engagement.", call: "Appeler", whatsapp: "WhatsApp", quote: "Demander un Devis" },
    contact: {
      num: "08", title: "Contacts", sub: "Parlez-nous — nous répondons en moins de 24 heures.",
      phone: "Téléphone", email: "Email", address: "Adresse",
      formTitle: "Demande de Devis", name: "Nom", phoneF: "Téléphone", emailF: "Email",
      service: "Quel service vous intéresse ?", servicePh: "Choisissez un service", message: "Message",
      submit: "Envoyer la Demande", sending: "Envoi...",
      success: "Merci ! Nous avons reçu votre demande et vous contacterons bientôt.",
      error: "Erreur d'envoi. Réessayez ou appelez-nous.",
    },
    footer: { desc: "Travaux professionnels de construction et en hauteur au Portugal. Sécurité, qualité et délais garantis.", nav: "Navigation", services: "Services", contacts: "Contacts", rights: "Tous droits réservés.", privacy: "Politique de Confidentialité", cookie: "Politique de Cookies" },
    mobile: { call: "Appeler", whatsapp: "WhatsApp", quote: "Devis" },
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("proalp_lang") || "pt");
  useEffect(() => {
    localStorage.setItem("proalp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
